<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="hide">
        <v-card class="card-container">
            <v-card-title class="title-container">
                <v-icon color="#FFFFFF" @click="hide" large class="mr-3">mdi-close-circle-outline</v-icon>
                {{ editMode ? $t('common.edit') : $t('common.add') }} {{ $t('common.note') }}
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12">
                        <kimsa-text-field
                            outlined no-elevation bolder-label
                            dense readonly
                            :label="$t('common.date')"
                            :value="date" force-value
                        />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-textarea-field
                            outlined no-elevation bolder-label
                            :label="$t('common.message')"
                            @change="message = $event"
                            :value="message" force-value
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-0 pb-0">
                <v-row no-gutters>
                    <v-col cols="12" v-if="editMode">
                        <v-btn block depressed x-large color="error" class="normal-btn no-radius"
                               :loading="loadingDelete"
                               @click="deleteNotes">
                            {{ $t('common.delete') }}
                        </v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn block depressed x-large color="primary" class="normal-btn no-radius black--text"
                               :disabled="disabled" @click="setNotes" :loading="loading">
                            {{ $t('common.save') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import {db, Timestamp} from "@/utils/Firebase";
import {mapMutations, mapState} from "vuex";
import KimsaTextareaField from "@/components/common/inputs/KimsaTextareaField";

export default {
    name: "NotesRoutineDialog",
    components: {KimsaTextareaField, KimsaTextField},
    props: {
        currentSelection: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            loadingDelete: false,
            routineNote: null,
            date: null,
            message: '',
            editMode: false,
            routineNoteDate: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        disabled(vm = this) {
            return !vm.message
        },
        routineNoteId(vm = this) {
            return vm.routineNote?.id || null
        },
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show(routineNote, date) {
            const vm = this
            vm.setDefaults(routineNote, date)
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.routineNote = null
            vm.message = ''
            vm.date = null
            vm.editMode = false
            vm.routineNoteDate = null
        },
        setDefaults(routineNote, date) {
            const vm = this
            vm.routineNote = routineNote
            vm.message = routineNote?.message || ''
            vm.date = routineNote?.messageDate || vm.$moment().format('DD-MM-YYYY')
            vm.editMode = !!vm.message
            vm.routineNoteDate = date
        },
        getGroupId() {
            const vm = this
            if (vm.currentSelection?.id || vm.currentSelection?.id === 0) return vm.currentSelection.id
            return null
        },
        async setNotes() {
            const vm = this
            if (vm.loadingDelete) return;
            vm.loading = true

            let noteDate = vm.$moment(vm.routineNoteDate)
            let dateFormatted = noteDate.format('YYYY-MM-DD')
            const [year, month, day] = dateFormatted.split('-');

            let payload = {
                studentId: vm.currentSelection?.objectID || null,
                teamId: vm.currentSelection?.teamId || null,
                groupId: vm.getGroupId(),
                date: Timestamp.fromDate(noteDate.toDate()),
                rawDate: {
                    full: dateFormatted,
                    day: day,
                    month: month,
                    year: year
                },
                message: vm.message,
                messageDate: vm.date,
            }

            vm.routineNoteId ?
                await db.collection('routineNotes').doc(vm.routineNoteId).update(payload) :
                await db.collection('routineNotes').add(payload)

            vm.loading = false
            vm.toast(vm.$t('common.note_saved'))
            vm.$emit('saved')
            vm.hide()
        },
        async deleteNotes() {
            const vm = this
            if (vm.loading) return;
            vm.loadingDelete = true

            await db.collection('routineNotes').doc(vm.routineNoteId).delete()

            vm.loadingDelete = false
            vm.toast(vm.$t('common.note_deleted'))
            vm.$emit('saved')
            vm.hide()
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

.card-container {
    border-radius: 8px;
    overflow: hidden;
}

.title-container {
    color: #FFFFFF;
    background: var(--v-backGroundPrimary-base);
}

</style>